import './Footer1.css';

import AndimarLogo from '../../assets/andimar/andimar-logo.svg';
import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';
import CommonService from '../../../../services/commonService';

const footerLinks = [
  { title: 'buy your tickets' },
  { title: 'destinations' },
  { title: 'offices' },
  { title: 'terms and conditions' },
  { title: 'contact' },
];

function Footer1() {
  const operator = CommonService.getLocal('op') || {};
  return (
    <div>
      <div className="footer1 less-bold-text" style={{ backgroundColor: '#161d4f' }}>
        <div className="logo-box">
          <img src={AndimarLogo} alt="" />
        </div>
        <div className="new-container">
          <div className="links-list">
            {/* {footerLinks.map((item, index, arr) => (
            <React.Fragment>
              {(index !== 0 || (index !== arr.length - 1 && index !== 0)) && (
                <span className="px-4">|</span>
              )}
              <span className="text-capitalize">{item.title}</span>
            </React.Fragment>
          ))} */}
            {operator &&
              operator.show_header_links &&
              operator.header_links.map((val, index, arr) => {
                return (
                  <a
                    // className="montserrat-bold"
                    key={index}
                    style={{
                      color: operator.text_color,
                      // marginRight: 15,
                      // marginLeft: 15,
                    }}
                    href={Object.values(val)}
                  >
                    {(index !== 0 || (index !== arr.length - 1 && index !== 0)) && (
                      <span className="px-4">|</span>
                    )}
                    {Object.keys(val)}
                  </a>
                );
              })}
            {operator && operator.operator_name == 'andimar' && <span className="px-4">|</span>}
            {operator && operator.operator_name == 'andimar' && (
              <a
                href="/privacy-policy"
                style={{
                  color: operator.text_color,
                }}
              >
                Política de privacidad
              </a>
            )}
          </div>
          <div className="contact-details mt-2">
            <div className="contact-details-item" style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={getIcons('TelephoneWhite', operator)}
                alt=""
                style={{ width: 20, marginRight: 5 }}
              />
              <span>Casa matriz (Horario hábil) (+56 2) 2683 8528 // (+56 2) 3304 8632</span>
              {/* <span>(+56 9) 4915 6683</span> */}
            </div>
            <span className="px-2">|</span>

            {/* <span className="px-2">|</span> */}

            <div className="contact-details-item">
              <img
                src={getIcons('EmailWhite', operator)}
                alt=""
                style={{ width: 20, marginRight: 5 }}
              />
              <span>{operator && operator.email}</span>
            </div>
          </div>
          <div
            style={{
              textAlign: 'center',
              marginBottom: '-13px',
              marginTop: '4px',
              color: '#161d4f',
            }}
          >
            EMPRESA DE TRANSPORTE DE PASAJEROS QUILICAL LIMITADA.
          </div>
        </div>
      </div>
      {operator && operator.show_bottom_footer ? <ShowBottomFooter operator={operator} /> : null}
    </div>
  );
}

const ShowBottomFooter = ({ operator }) => {
  return (
    <div
      className="d-flex-c f-13 p-2"
      style={{
        background: operator && operator.color_codes ? operator.color_codes.sub_footer_color : '',
        color: operator.text_color,
      }}
    >
      <div>
        <span>{operator.name} 2022 </span>
        <span>
          {' '}
          - Todos los derechos reservados{' '}
          {operator && operator.operator_name != 'andimar' && '© | Powered by'}{' '}
        </span>
        {operator && operator.operator_name != 'andimar' && (
          <a href="https://kupos.cl" target="_blank">
            <img
              src={getIcons('kuposLogo', operator)}
              // alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
              className="footer-kupos-logo"
              alt=""
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default Footer1;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/Footer1.js